import { Alert } from 'components';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectQueue } from 'redux/slices/snackbar/snackbarSlice';

const SnackBar = () => {
  const alertInfo = useSelector(selectQueue);
  return (
    <>
      {alertInfo?.map((item) => (
        <Alert
          key={item.id}
          id={item.id}
          message={item.message}
          duration={item.duration || 2000}
          showAlert={item.show}
          position={item.position}
          status={item.status}
        />
      ))}
    </>
  );
};

export default SnackBar;
